import commentAxios from 'api/commentsAxios'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import moment from 'moment'

const TableWrapper = styled.div`
  .blue,
  th {
    color: #3985b9;
    user-select: none;
  }
  .pointer {
    cursor: pointer;
  }
  button {
    user-select: none;
  }
  table {
    margin: 0;
    margin-bottom: 10px;
  }
`

const Main = styled.div`
  .select-sort {
    width: fit-content;
    padding: 0 1.5rem;
    label {
      margin-bottom: 8px;
    }
    select {
      padding: 6px;
    }
  }
`

const RepliesTable = ({ comment_id = '', type, content_id }) => {
  const [sortConfig, setSortConfig] = useState({
    lastKey: null,
    loadMore: false,
    content_type: 'CLASS'
  })
  const [data, setData] = useState([])
  const [lastKey, setLastKey] = useState(null)
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)

  const fetchData = useCallback(
    async ({ lastKey, loadMore = false }) => {
      try {
        setLoading(true)
        const res = await commentAxios.post('/replies', {
          content_type: type,
          content_id,
          comment_id,
          limit: 10,
          last_evaluated_key: lastKey
        })
        const data = res.data?.replies || []
        setTotal(res?.data?.replyCount || 0)
        setData((state) => {
          if (loadMore) {
            return [...state, ...data]
          }
          return data
        })
        setLastKey(res?.data?.lastEvaluatedKey)
      } catch (err) {
        console.log(err)
        setData([])
      } finally {
        setLoading(false)
      }
    },
    [type, comment_id, content_id]
  )

  useEffect(() => {
    fetchData(sortConfig)
  }, [fetchData, sortConfig])

  const handlePagination = () => {
    setSortConfig((prev) => ({
      ...prev,
      lastKey,
      loadMore: true
    }))
  }

  const handleDelete = (reply_id) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete this reply`
    )
    if (confirmed) {
      commentAxios
        .post('/content-interaction/delete', {
          content_type: type,
          content_id,
          comment_id,
          reply_id
        })
        .then((res) => {
          if (res.data?.success) {
            setLastKey(null)
            setSortConfig((state) => ({
              ...state,
              lastKey: null,
              loadMore: false
            }))
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
  return (
    <Main>
      <TableWrapper>
        <table className='table table-bordered table-striped'>
          <thead className='table-light'>
            <tr>
              <th role='button'>Reply</th>
              <th>User</th>
              <th role='button'>Likes</th>
              <th role='button'>Date</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <Fragment key={index}>
                <tr key={index}>
                  <td>{row.text}</td>
                  <td>{row.user?.fullName}</td>
                  <td>{row.likes}</td>
                  <td className='td-date'>
                    {moment(row.updatedAt).local().format('MM/DD/YYYY HH:mm')}
                  </td>
                  <td>
                    <a
                      className='blue'
                      role='button'
                      onClick={() => handleDelete(row.replyId)}
                    >
                      DELETE
                    </a>
                  </td>
                </tr>
              </Fragment>
            ))}
          </tbody>
        </table>
        <div className='text-left my-3'>
          <Button
            classID='load-more'
            variant='primary'
            onClick={handlePagination}
            disabled={!Boolean(lastKey) || loading || total == data.length}
          >
            {loading
              ? 'Loading...'
              : Boolean(lastKey) && total !== data.length
              ? 'Load More'
              : 'No More Items'}
          </Button>
        </div>
      </TableWrapper>
    </Main>
  )
}

export default RepliesTable
